import React from "react";
import { DoctorVisitIcon } from "../../../components/Icons";

interface IDoctorVisitToggleCard{
  handleToggle: () => void;

}

const DoctorVisitToggleCard = ({ handleToggle }: IDoctorVisitToggleCard) => {
  const handleCardClick = () =>{
    handleToggle();
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-2">
        <div className="font-semibold text-sm">Looking for Other Services?</div>
        <div className="text-gray-1 text-sm">We’ll take you to another calendar to find times.</div>
      </div>
      <div
        onClick={()=> handleCardClick()}
        className="cursor-pointer border border-taupe-50 flex gap-3 bg-white
      rounded-lg p-3 items-center hover:bg-gv-yellow-light hover:gv-yellow">
        <div className="flex items-center justify-center bg-taupe-4 rounded-full p-2 h-fit">
          <DoctorVisitIcon width={20} height={20} />
        </div>
        <div className="font-semibold text-sm">
            Book a Doctor Visit
        </div>
      </div>
    </div>
  );
};

export default DoctorVisitToggleCard;
